/** Homepage trust comparison — marketplace vs reDevicer Verified. */

export type TrustCompareStatus = 'yes' | 'no' | 'partial'

export type TrustCompareRowId =
  | 'inspection47'
  | 'warehouseInspection'
  | 'devicePassport'
  | 'platformWarranty'
  | 'returns14'
  | 'escrowPayment'
  | 'verifiedReport'

export interface TrustCompareRow {
  id: TrustCompareRowId
  marketplace: TrustCompareStatus
  verified: TrustCompareStatus
}

/** Rows focus on platform-exclusive Verified benefits — not generic listing features. */
export const TRUST_COMPARE_ROWS: TrustCompareRow[] = [
  { id: 'inspection47', marketplace: 'no', verified: 'yes' },
  { id: 'warehouseInspection', marketplace: 'no', verified: 'yes' },
  { id: 'devicePassport', marketplace: 'no', verified: 'yes' },
  { id: 'verifiedReport', marketplace: 'no', verified: 'yes' },
  { id: 'platformWarranty', marketplace: 'no', verified: 'yes' },
  { id: 'returns14', marketplace: 'yes', verified: 'yes' },
]

export function trustCompareRowLabelKey(id: TrustCompareRowId): string {
  return `trust.compare.row.${id}`
}

export function trustCompareStatusLabelKey(status: TrustCompareStatus): string {
  return `trust.compare.status.${status}`
}
